export const I18N_COMMON_CONTEXT = 'common';
export const WELCOME = 'welcome';
export const LOGIN = 'log-in';
export const LOGOUT = 'log-out';
